// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4cf88cfd","455":"44e4151e","952":"3ba2f275"}[chunkId] + ".chunk.js";
};